export enum Type {
  DISPLAY_PREF_GET_REQUEST = 'app/display-pref/DISPLAY_PREF_GET_REQUEST',
  DISPLAY_PREF_GET_SUCCESS = 'app/display-pref/DISPLAY_PREF_GET_SUCCESS',
  DISPLAY_PREF_GET_FAILURE = 'app/display-pref/DISPLAY_PREF_GET_FAILURE',
}
